module.exports = __webpack_public_path__ + "static/media/reputation-vitalik.3147d0e6.jpg";